/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Заказ
 * @export
 * @interface PayOrder200ResponseDataOrder
 */
export interface PayOrder200ResponseDataOrder {
  /**
   *
   * @type {number}
   * @memberof PayOrder200ResponseDataOrder
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof PayOrder200ResponseDataOrder
   */
  userUuid: string
  /**
   *
   * @type {string}
   * @memberof PayOrder200ResponseDataOrder
   */
  number: string
  /**
   *
   * @type {number}
   * @memberof PayOrder200ResponseDataOrder
   */
  currencyId: number
  /**
   *
   * @type {number}
   * @memberof PayOrder200ResponseDataOrder
   */
  price: number
  /**
   *
   * @type {string}
   * @memberof PayOrder200ResponseDataOrder
   */
  notes?: string | null
  /**
   *
   * @type {Date}
   * @memberof PayOrder200ResponseDataOrder
   */
  dateHoldPrice?: Date | null
  /**
   *
   * @type {number}
   * @memberof PayOrder200ResponseDataOrder
   */
  ownerSysObjectId: number
}

/**
 * Check if a given object implements the PayOrder200ResponseDataOrder interface.
 */
export function instanceOfPayOrder200ResponseDataOrder(
  value: object
): value is PayOrder200ResponseDataOrder {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('userUuid' in value) || value['userUuid'] === undefined) return false
  if (!('number' in value) || value['number'] === undefined) return false
  if (!('currencyId' in value) || value['currencyId'] === undefined)
    return false
  if (!('price' in value) || value['price'] === undefined) return false
  if (!('ownerSysObjectId' in value) || value['ownerSysObjectId'] === undefined)
    return false
  return true
}

export function PayOrder200ResponseDataOrderFromJSON(
  json: any
): PayOrder200ResponseDataOrder {
  return PayOrder200ResponseDataOrderFromJSONTyped(json, false)
}

export function PayOrder200ResponseDataOrderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PayOrder200ResponseDataOrder {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    userUuid: json['userUuid'],
    number: json['number'],
    currencyId: json['currencyId'],
    price: json['price'],
    notes: json['notes'] == null ? undefined : json['notes'],
    dateHoldPrice:
      json['dateHoldPrice'] == null
        ? undefined
        : new Date(json['dateHoldPrice']),
    ownerSysObjectId: json['ownerSysObjectId'],
  }
}

export function PayOrder200ResponseDataOrderToJSON(
  value?: PayOrder200ResponseDataOrder | null
): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    userUuid: value['userUuid'],
    number: value['number'],
    currencyId: value['currencyId'],
    price: value['price'],
    notes: value['notes'],
    dateHoldPrice:
      value['dateHoldPrice'] == null
        ? undefined
        : (value['dateHoldPrice'] as any).toISOString(),
    ownerSysObjectId: value['ownerSysObjectId'],
  }
}
